import 'regenerator-runtime/runtime';
import './text-flipper';
import './explainer';
import './toggle';
import './nav';
import './pan-wrap';

import { LuminousGallery } from 'luminous-lightbox';

/**
 * Add a class to the document element when the user has scrolled
 */
window.addEventListener(
	'scroll',
	() => {
		document.documentElement.classList.toggle(
			'scrolled-down',
			window.scrollY > 10,
		);
	},
	{ passive: true },
);

new LuminousGallery(document.querySelectorAll('[data-product-image]'));
